/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { __assign, __rest } from "tslib";
import React from "react";
import { ICON_SIZE_STANDARD, ICON_SIZE_LARGE } from "../../constants";
import * as Classes from "../../classes";
export var ChevronDown = function (_a) {
    var className = _a.className, color = _a.color, _b = _a.size, size = _b === void 0 ? ICON_SIZE_STANDARD : _b, _c = _a.title, title = _c === void 0 ? "chevron-down" : _c, _d = _a.htmlTitle, htmlTitle = _d === void 0 ? title : _d, _e = _a.tagName, tagName = _e === void 0 ? "span" : _e, htmlProps = __rest(_a, ["className", "color", "size", "title", "htmlTitle", "tagName"]);
    var isLarge = size >= ICON_SIZE_LARGE;
    var pixelGridSize = isLarge ? ICON_SIZE_LARGE : ICON_SIZE_STANDARD;
    var viewBox = "0 0 " + pixelGridSize + " " + pixelGridSize;
    var path = (React.createElement("path", { d: isLarge
            ? "M16 14C15.72 14 15.47 13.89 15.29 13.71L10 8.41L4.71 13.71C4.53 13.89 4.28 14 4 14C3.45 14 3 13.55 3 13C3 12.72 3.11 12.47 3.29 12.29L9.29 6.29C9.47 6.11 9.72 6 10 6S10.53 6.11 10.71 6.29L16.71 12.29C16.89 12.47 17 12.72 17 13C17 13.55 16.55 14 16 14z"
            : "M12 11C11.72 11 11.47 10.89 11.29 10.71L8 7.41L4.71 10.71C4.53 10.89 4.28 11 4 11C3.45 11 3 10.55 3 10C3 9.72 3.11 9.47 3.29 9.29L7.29 5.29C7.47 5.11 7.72 5 8 5S8.53 5.11 8.71 5.29L12.71 9.29C12.89 9.47 13 9.72 13 10C13 10.55 12.55 11 12 11z", fillRule: "evenodd" }));
    if (tagName === null) {
        return (React.createElement("svg", __assign({ fill: color, "data-icon": "chevron-down", width: size, height: size, viewBox: viewBox }, htmlProps),
            title && React.createElement("desc", null, title),
            path));
    }
    else {
        return React.createElement(tagName, __assign(__assign({}, htmlProps), { className: className + " " + Classes.ICON, title: htmlTitle }), React.createElement("svg", { fill: color, "data-icon": "chevron-down", width: size, height: size, viewBox: viewBox },
            title && React.createElement("desc", null, title),
            path));
    }
};
export default ChevronDown;
//# sourceMappingURL=chevron-down.js.map